export var PageName;
(function (PageName) {
    PageName["Home"] = "home_page";
    PageName["Login"] = "login_page";
    PageName["SignUp"] = "signup_page";
})(PageName || (PageName = {}));
